import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWritePhysicalInformation: Map<string, ConfirmationData> = new Map([

    ["ed139359-254f-48b0-ac70-9707cdb2dcc4|4ce75734-5023-4c15-a37e-0004de0d83e5", { label: "Peso en kilogramos" }],
    ["f518b021-1b7b-4cd7-9d9f-a5426c2d36ef|2a72a640-b4ac-40dd-8e45-94aa9f07da9f", { label: "Talla en metros" }],
    ["85a2ff61-5730-4382-80af-1b145b591df0", { hidden: true }],
    ["17c769ad-84cb-4a4d-99e7-b8a1bff05f1e", { hidden: true }],
    ["db0f1a91-2dab-4504-8610-d6c7849b2a3f|35ba1e0f-cab1-4433-8b5e-765037412c17", { fontWeight: "bold", showBorder: false }],
]);



